<ng-template #contentTemplate>
    <ng-container *ngIf="icon?.name && icon?.position === iconPosition.LEFT">
        <app-svg-icon [icon]="icon.name" [color]="iconColor"></app-svg-icon>
    </ng-container>
    <ng-content></ng-content>
    <ng-container *ngIf="icon?.name && icon?.position === iconPosition.RIGHT">
        <app-svg-icon [icon]="icon.name" [color]="iconColor"></app-svg-icon>
    </ng-container>
</ng-template>

<ng-container *ngIf="href; else useButton">
    <a href="{{ href }}" [attr.target]="target" [class.disabled]="disabled"
        [class.secondary]="type === buttonType.SECONDARY" [class.text]="type === buttonType.TEXT"
        [class.icon-left]="icon?.position === iconPosition.LEFT"
        [class.icon-right]="icon?.position === iconPosition.RIGHT" [class.full-width]="fullWidth">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </a>
</ng-container>

<ng-template #useButton>
    <button [disabled]="disabled" [class.secondary]="type === buttonType.SECONDARY"
        [attr.type]="submitType ? 'submit' : 'button'" [class.text]="type === buttonType.TEXT"
        [class.icon-left]="icon?.position === iconPosition.LEFT"
        [class.icon-right]="icon?.position === iconPosition.RIGHT" [class.full-width]="fullWidth">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </button>
</ng-template>